import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useHistory } from "react-router-dom";

import MaterialTable from "material-table";
import Sidebar from '../../Template/Sidebar/Sidebar';
import Header from '../../Template/Header/Header';
import {baseUrl} from '../../../config';
import DatePicker from "react-datepicker";
import './consumption.css';
import moment from 'moment'
import CloseIcon from '@mui/icons-material/Close';
import "react-datepicker/dist/react-datepicker.css";
import {formatNumberWithToFixed} from '../ProfitabilityDiagnosis/js/commanFn';

import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import Loader from 'react-loader-spinner';

import './review.css'
import { yellow } from '@mui/material/colors';
import {clickColor,inArray} from './../../../library/util';
import axiosIntance from '../../../helper/axios';


function AffiliateReview() {
    const history = useHistory();
    const [selectedRow, setSelectedRow] = useState(null);
    const ReportTile='Affiliate Conversion Tracking and Review';
   // const [startDate, setStartDate] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 1));

    const [startDate, setStartDate] = useState(new Date(Date.now() - 864e5).setHours(0,0,0,0));
    const [endDate, setEndDate] = useState(new Date(Date.now() - 864e5).setHours(23,59,0,0));

    const [AFFID,setAFFID]=useState('');
    const [AFFIDArray,setAFFIDArray]=useState([]);
    const [selectedrowList,setSelectedRowList]=useState([]);
    const handleSignOut = () => {
        window.localStorage.setItem('isLogin',false);
        history.push('/');
      }
   
    if(localStorage.getItem('isLogin')==="false" || localStorage.getItem('isLogin')==null){
      history.push('/');
    }

    checkUserTypeFn(history);  

    function checkUserTypeFn(history){
      const userdata=JSON.parse(localStorage.getItem('userdata'));
      const usertype=userdata.type;
      console.log('in check usertype fn');
      console.log(usertype)
      if(usertype!='admin' && usertype!='superadmin' && usertype!='subadmin' && usertype!='user' && usertype!='owneradmin'){
        history.push('/');
     }
    }

    const setRowBackground = (selectedRow)=>{
      console.log('hey');
      console.log('38 ====')
      console.log(selectedRow)
      let tempObj={};
      // tempObj[selectedRow.tableData.id]=false;
      // console.log(tempObj)
      // setTempBool()
      console.log(selectedRow.tableData.id)
      console.log(selectedrowList)
      if(inArray(selectedRow.tableData.id,selectedrowList)==false){ 
        console.log('here')
      setSelectedRowList(oldArray => [...oldArray,selectedRow.tableData.id] );
      setSelectedRow(selectedRow.tableData.id)
      console.log(selectedrowList)
      }else{
        console.log('here not')
        setSelectedRow(5000)
        //setSelectedRowList(oldArray => [...oldArray,selectedRow.tableData.id] );
        removeItemOnce(selectedrowList,selectedRow.tableData.id);
        
      }
      console.log('52 line')
      console.log(selectedrowList)
      
      
    }



  
    const [reportData,setReportData]=useState([])
    const [loader,setLoader]=useState(false)
    
    const [message, setMessage] = useState('')
    const data = [['attribute', 'attribute2'], ['value1', 'value2']];
    const [successMsg,setSuccessMsg]=useState('')
    useEffect(() => {
      //fetchApi();
      return () => {
        console.log('un subscribe')
      }
  
  
  
    }, [])
    
    const ResetFilter = () => {
      setMessage('')
      setEndDate(new Date(Date.now()))
      setStartDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
    }
   
  const fetchApi = () =>{
    console.log('here check')
    console.log(startDate)
    if(startDate==null){
      setMessage('Date must not be blank')
      return false;
    }else{
      setMessage('')
    }
    setLoader(true)
    let affidStr=AFFIDArray.join(',');
    console.log(affidStr)
    
    
axiosIntance.get(baseUrl+'/reports/salesperformance/affiliateReview?startdate='+moment(startDate).format('YYYY-MM-DD HH:mm:ss')+"&enddate="+moment(endDate).format('YYYY-MM-DD HH:mm:ss'), {}).then(response => {

    
        if (response.data.result.length > 0) {
          console.log('data we have')
          response.data.result.forEach((i,j)=>{
            console.log(i);
            i.scrub_percent=roundToTwo(i.scrub_percent*100)+"%";
            i.everflow_cpa="$"+formatNumberWithToFixed(i.everflow_cpa).toLocaleString();
            i.effective_cpa="$"+formatNumberWithToFixed(i.effective_cpa).toLocaleString();
           
           
          });
          setReportData(response.data.result);
          
          console.log(response.data.result)
          setLoader(false)
          //setSuccessMsg('Data')
        } else {
          setLoader(false)
          setReportData([]);
          //setMessage('No data');
          console.log(45)
         // history.push('/home');
        }
  
      }).catch(error => {
        setLoader(false)
        setMessage('Something went wrong');
      });
  }

  const fetchApiDownload = () =>{

    let affidStr=AFFIDArray.join(',');
    console.log(affidStr)
    const token = window.localStorage.getItem('token');
      window.location.href=baseUrl+'/reports/salesperformance/affiliateReview/download?startdate='+moment(startDate).format('YYYY-MM-DD HH:mm:ss')+"&enddate="+moment(endDate).format('YYYY-MM-DD HH:mm:ss')+"&token="+token;
    
  }

  const FilterSet=() =>{
    console.log('Filter resete');
    console.log(AFFID);
    if(AFFID!=''){
        if(inArrayForString(AFFID,AFFIDArray)==false){ 
        setAFFIDArray(oldArray => [...oldArray,AFFID] );
        setAFFID('');
        }
      } 
    }
   
  

    const deleteAFFIDFn = (item,index) =>{
        console.log(item);
        removeItemOnce(AFFIDArray,item);
        console.log(AFFIDArray);
    
        let temp = AFFIDArray.filter((category) => category !== item);
        console.log(temp);
        setAFFIDArray(temp);
      }
  
  
  function removeItemOnce(arr, value) {
    var index = arr.indexOf(value);
    if (index > -1) {
      arr.splice(index, 1);
    }
    return arr;
  }
   
   
    return (
  
      <div id="wrapper" className>
        <Sidebar />
        <Header handleSignOut={handleSignOut} />



  <div></div> 
  <div></div>
  <div></div> 
  <div></div>
     
      <div className='errorMsg'>{message}</div>
      <div className='successMsg viewScreen'>{successMsg}</div>
  
  
  
  
    
  
  
    <section id="content-wrapper">

    <label>Date for Report</label>
    <div class="input-bar">
    <div className="input-bar-item width100">
    
    <DatePicker
      dateFormat="yyyy-MM-dd HH:mm"
      selected={startDate}
      className='width140x'
      onChange={(date) => setStartDate(date)}
      placeholder='Start Date'

      showTimeSelect
      timeFormat="p"
      timeIntervals={15}
      />

    </div>
    
    &nbsp;&nbsp;&nbsp;
 
    <div className="input-bar-item width100">
    
    <DatePicker
      
      selected={endDate}
      className='width140x'
      onChange={(date) => setEndDate(date)}
      placeholder='End Date'

      dateFormat="yyyy-MM-dd HH:mm"
      showTimeSelect
      timeFormat="p"
      timeIntervals={15}
      />
      
    </div>
    &nbsp;&nbsp;&nbsp;

    &nbsp;&nbsp;&nbsp;
{/*  
    <div className="input-bar-item">
    
    <input type='text'
     name='affid'
     value={AFFID}
     className='width50x'
     placeholder="AFFID"
     onChange={e => setAFFID(e.target.value)}
     />
      
    </div> */}

    {/* <div className="input-bar-item">
    <button type="button"  onClick={FilterSet} className="btn btn-primary">Filter</button>
   
    </div> */}
    <div class="input-bar-item">
    <button type="button"  onClick={fetchApi} className="btn btn-primary">Run Report</button>
   
    </div>
    <div class='input-bar-item'>
    <button type="button"  onClick={ResetFilter} className="btn btn-primary">Reset</button>
    </div>

    {/* <div className='downloadReportBtn'>
        {
          
          reportData.length>0 ? <button type="button"  onClick={fetchApiDownload} className="btn btn-primary">Download Report in Excel</button>:''
         
        }
       
      </div> */}

<div className='downloadReportBtn'>
        {
          
          <button type="button"  onClick={fetchApiDownload} className="btn btn-primary">Download Report in Excel</button>
         
        }
       
      </div>
  </div>

  <div className="FilterSection">
  
  {AFFIDArray.map((item, index) => (
      <span className="FilterSection"> 
       <span className='filterCategory' id={index}><span className="filterSpan">AFFID = {item}{ }</span>
       <span  onClick={(event) => deleteAFFIDFn(item,index)}><CloseIcon className='closeIcon'/></span>
       </span>
       <span className="whitespaceSpan">{ '            ' }</span>
       </span>
      
    ))}




    
  </div>

  {loader ?
  <div className='loaderDiv'>  
  <Loader type="ThreeDots" color="#2BAD60" height="100" width="100" /></div> : 
  
          <MaterialTable
          // onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}

          onRowClick={((evt, selectedRow) => 
            setRowBackground(selectedRow)
            )}
            columns={[

              { title: "AFFID", field: "affid" },
              { title: "Affiliate", field: "affiliate_name" },
              { title: "C1", field: "c1" },
              { title: "Offer.Name", field: "offer_name" },
              { title: "Campaign.Name", field: "campaign_name" },
              { title: "Sticky.Total.Sales", field: "sticky_total_sales" },
              { title: "Sticky.Scrubbed.Sales", field: "sticky_scrubbed_sales" },
              { title: "Sticky.Tracked.Sales", field: "sticky_tracked_sales" },

              { title: "Everflow.Tracked.Conversions", field: "everflow_tracked_conversions" },
              { 
                title: "Overbilled", 
                field: "overbilled",
                cellStyle: (e,
                rowdata)=>{
                  if(rowdata.overbilled>0){
                    console.log(rowdata)
                    console.log(e)
                    return{
                      fontWeight: 'bold',
                      fontSize:'25pt !important',
                      
                      color:'red'
                    }
                  }else if(rowdata.overbilled<0){
                    return{
                      fontWeight: 'bold',
                      fontSize: "1.5em", 
                      //  fontSize:'35pt !important',
                        textDecoration:'underline',
                       textDecorationColor:'black',
                      //fontSize:[25,"!important"],
                      color:'green',
                      
                    }
                  }
                } },
              { title: "Scrub.Percent", field: "scrub_percent" },
              { title: "Everflow.CPA", field: "everflow_cpa" },

              { title: "Effective.CPA", field: "effective_cpa" },
             
             
             
            ]}
            data={
                reportData
            }
            
             title={ReportTile}
            
            options={{
                actionsColumnIndex: -1,
                addRowPosition: "first",
                pageSize:10,
                loadingType: 'linear',
                paging: false,
                exportButton: true,
                maxBodyHeight: '500px',
                headerStyle: { position: 'sticky', top: 0,fontSize:'17px',fontWeight:'bold' },
                rowStyle: rowData => ({
                  backgroundColor: (selectedRow === rowData.tableData.id) ? clickColor : ''
                })
                
             
                
              }}
              
          />
        }
        </section>
       
      </div>

    )
}

function inArrayForString(needle, haystack) {
  var length = haystack.length;
  for (var i = 0; i < length; i++) {
  if (haystack[i].toLowerCase() == needle.toLowerCase())
   return true;
  }
  return false;
 }

function roundToTwo(num) {    
  return +(Math.round(num + "e+2")  + "e-2");
}

export default AffiliateReview
